module.exports = __webpack_public_path__ + "img/trico-logo.ed20d9c6.svg";